import { ContextMenuItemView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';

export function UnitLocationItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    const handleSelect = (): void => {
        drawerControls.open({
            type: 'unit-location',
            props: { unitId: clickParams.unitId },
        });
    };

    return (
        <ContextMenuItem
            dataPendoId="menu-item-unit-location"
            contextMenuItemView={contextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
